import { Component } from '@angular/core';

@Component({
	selector: 'app-reservation-summary-dialog-handler',
	templateUrl: './reservation-summary-dialog-handler.component.html',
	styleUrls: ['./reservation-summary-dialog-handler.component.scss'],
})
export class ReservationSummaryDialogHandlerComponent {
	constructor() {}
}
